import React, { useEffect, useState } from 'react';
import { estadoPush, ativarPush } from '../push/push';

// Banner que aparece na tela de Atendimentos quando as notificacoes ainda nao
// foram ativadas neste aparelho. Antecipa a intencao (igual ao WhatsApp Web, que
// oferece ligar os avisos) e resolve o problema de descoberta: no mobile o toggle
// da sidebar fica escondido atras do hamburguer. Some quando ligado ou dispensado.
const DISMISS_KEY = 'fio_aviso_push_dismiss';

export default function BannerAtivarAvisos() {
  const [estado, setEstado] = useState(null);
  const [busy, setBusy] = useState(false);
  const [dispensado, setDispensado] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
  });

  useEffect(() => { estadoPush().then(setEstado).catch(() => {}); }, []);

  if (dispensado || !estado || !estado.suportado) return null;
  const inscrito = estado.inscrito && estado.permissao === 'granted';
  if (inscrito) return null;

  const ativar = async () => {
    setBusy(true);
    try {
      await ativarPush();
      setEstado(await estadoPush());
    } catch (e) {
      // silencioso — o usuario pode tentar de novo pelo mesmo botao
    } finally {
      setBusy(false);
    }
  };

  const dispensar = () => {
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch (e) { /* ignore */ }
    setDispensado(true);
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '10px 14px', borderRadius: 10, marginBottom: 10,
      background: 'rgba(61,139,55,0.10)', border: '1px solid rgba(61,139,55,0.35)',
    }}>
      <i className="bi bi-bell-fill" style={{ color: '#3D8B37', fontSize: '1.1rem', flexShrink: 0 }} />
      <span style={{ flex: 1, fontSize: '0.85rem', color: 'var(--portal-text)' }}>
        Ative os avisos pra saber na hora que chegar mensagem — mesmo com o app fechado.
      </span>
      <button
        type="button"
        className="btn btn-sm"
        onClick={ativar}
        disabled={busy}
        style={{ background: '#3D8B37', color: '#fff', border: 'none', whiteSpace: 'nowrap' }}
      >
        {busy ? '...' : 'Ativar avisos'}
      </button>
      <button
        type="button"
        onClick={dispensar}
        aria-label="Dispensar"
        title="Dispensar"
        style={{
          background: 'transparent', border: 'none', color: 'var(--portal-muted)',
          cursor: 'pointer', fontSize: '1.05rem', lineHeight: 1, flexShrink: 0,
        }}
      >
        <i className="bi bi-x-lg" />
      </button>
    </div>
  );
}
